<script>
    /**
     * The one-time 18+ attestation. Rendered once at the top-bar root, NOT
     * inside the dropdown that opens it — see sensitiveContent.js.
     *
     * Copy is bilingual in one string rather than i18n: svelte-i18n picks the
     * locale from getLocaleFromNavigator(), so a Taiwanese user on an en-US
     * browser would get the age attestation in English only, and a legal
     * statement can't depend on the navigator locale.
     */
    import * as AlertDialog from "~/components/ui/alert-dialog";
    import { ageDialogOpen, applySensitive } from "~/components/sensitiveContent";
</script>

<AlertDialog.Root bind:open={$ageDialogOpen}>
    <AlertDialog.Content>
        <AlertDialog.Header>
            <AlertDialog.Title>顯示敏感內容 / Show sensitive content</AlertDialog.Title>
            <AlertDialog.Description>
                開啟後，被標記為「露骨」的內容會出現在瀏覽與搜尋結果中。
                <br />
                Turning this on makes content rated explicit appear in browsing
                and search results.
            </AlertDialog.Description>
        </AlertDialog.Header>
        <AlertDialog.Footer>
            <AlertDialog.Cancel>取消 / Cancel</AlertDialog.Cancel>
            <AlertDialog.Action onclick={() => applySensitive(true)}>
                我已滿 18 歲 / I am 18 or older
            </AlertDialog.Action>
        </AlertDialog.Footer>
    </AlertDialog.Content>
</AlertDialog.Root>
